import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import ReactPlayer from 'react-player';
import { requestGet } from '../../api/request';
import { FILM_BY_ID, MAIN_URL } from '../../api/url';
import { BreadcrumbComponent } from '../Partials/Breadcrumb';
import EventMore from '../Event/EventMore';
import Map from '../Home/Map';
import * as actions from '../../redux/actions';

const FilmById = () => {
  const { filmId } = useParams();
  const [loader, setLoader] = useState(false);

  const dispatch = useDispatch();

  const [data, setData] = useState();

  const dictionary = useSelector((state) => state.dictionaryReducer.dictionary);
  const currentLanguage = useSelector(
    (state) => state.languageReducer.current_language,
  );
  const fontSize = useSelector((state) => state.fontSizeReducer.font_size);

  // Player state
  const [playing, setPlaying] = useState(false);
  const [volume, setVolume] = useState(0.8);
  const [played, setPlayed] = useState(0);
  const [seeking, setSeeking] = useState(false);
  const [duration, setDuration] = useState(0);
  const [elapsed, setElapsed] = useState(0);
  const playerRef = React.useRef();

  const getData = async () => {
    setLoader(true);
    const response = await requestGet(FILM_BY_ID, {
      'id': filmId,
      'lang_id': currentLanguage.id,
    });

    if (response.success) {
      setLoader(false);
      setData(response.data);
    }
  };

  useEffect(() => {
    getData();
  }, [filmId]);

  useEffect(() => {
    if (data) {
      dispatch(actions.adjustFontSize(fontSize));
    }
  });

  const sliderBackgroundChange = (state) => {
    const slider = document.getElementById('duration_slider');
    slider.style.cssText = `
          background: linear-gradient(90deg, rgb(226, 226, 226) ${state * 100}%, rgb(59, 107, 59) ${state * 100}%)
          `;
  };

  const handlePlayPause = () => {
    const playButton = document.getElementById('play_button');
    const pauseButton = document.getElementById('pause_button');
    if (playing === true) {
      setPlaying(false);
      pauseButton.style.display = 'none';
      playButton.style.display = 'inline-block';
    } else {
      setPlaying(true);
      playButton.style.display = 'none';
      pauseButton.style.display = 'inline-block';
    }
  };

  const handleVolumeLevel = (e) => {
    const { target } = e;
    setVolume(parseFloat(target.value));
    const slider = document.getElementById('volume_slider');
    slider.style.cssText = `
          background: linear-gradient(90deg, rgb(226, 226, 226) ${target.value * 100}%, rgb(59, 107, 59) ${target.value * 100}%)
          `;
  };

  const handleSeekMouseDown = () => {
    setSeeking(true);
  };

  const handleSeekChange = (e) => {
    const { target } = e;
    setPlayed(parseFloat(target.value));
    sliderBackgroundChange(target.value);
    playerRef.current.seekTo(parseFloat(target.value));
  };

  const handleSeekMouseUp = () => {
    setSeeking(false);
  };

  const handleProgress = (state) => {
    // We only want to update time slider if we are not currently seeking
    if (seeking === false) {
      setPlayed(state.played);
      setElapsed(state.playedSeconds);
      sliderBackgroundChange(state.played);
    }
  };

  const handleClickFullscreen = async () => {
    const container = document.getElementById('wrapper');
    const fullscreenApi = container.requestFullscreen
      || container.webkitRequestFullScreen
      || container.mozRequestFullScreen
      || container.msRequestFullscreen;
    if (!document.fullscreenElement) {
      fullscreenApi.call(container);
    } else {
      document.exitFullscreen();
    }
  };

  const handleDuration = (duration) => {
    setDuration(duration);
  };

  function fancyTimeFormat(recievedTime) {
    const hrs = Math.floor(recievedTime / 3600);
    const mins = Math.floor((recievedTime % 3600) / 60);
    const secs = Math.floor(recievedTime % 60);
    let time = '';
    if (hrs > 0) {
      time += `${hrs}:${(mins < 10 ? '0' : '')}`;
    }
    time += `${mins}:${(secs < 10 ? '0' : '')}`;
    time += secs;
    return time;
  }

  return (
    <section className="section">
      <div className="container">
        <div className="row">
          <div className="col-lg-9">
            <div className="breadcrumbs mt-4">
              <div className="breadcrumbs-container">
                <BreadcrumbComponent />
              </div>
            </div>
            {loader === true ? (
              <div className="row d-flex justify-content-md-center align-items-center mt-3 mb-3">
                <div className="spinner-border text-success" role="status">
                  <span className="sr-only" />
                </div>
              </div>
            ) : null}
            {data ? (
              <div className="film-item">
                <div className="film-item__player">
                  <div id="wrapper" className="player-wrapper">
                    <div id="controls" className="controls">
                      <a
                        href=""
                        id="play_button"
                        title="Play"
                        onClick={(e) => {
                          e.preventDefault();
                          handlePlayPause();
                        }}
                      >
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path fillRule="evenodd" clipRule="evenodd" d="M0 3.79214C0 0.863688 3.10426 -0.95627 5.5667 0.528516L19.1789 8.73638C21.607 10.2004 21.607 13.7996 19.1789 15.2636L5.5667 23.4715C3.10426 24.9563 0 23.1363 0 20.2079V3.79214Z" fill="white" />
                        </svg>
                      </a>
                      <a
                        href=""
                        id="pause_button"
                        style={{ display: 'none' }}
                        title="Pause"
                        onClick={(e) => {
                          e.preventDefault();
                          handlePlayPause();
                        }}
                      >
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path fillRule="evenodd" clipRule="evenodd" d="M0.221214 1.092C1.41561e-07 1.51867 0 2.07867 0 3.2V20.8C0 21.92 1.41561e-07 22.48 0.221214 22.908C0.416674 23.2842 0.728324 23.5899 1.1115 23.7813C1.54579 24 2.11579 24 3.25714 24H3.52857C4.66857 24 5.23857 24 5.67421 23.7827C6.0576 23.5909 6.36927 23.2847 6.5645 22.908C6.78571 22.4813 6.78571 21.9213 6.78571 20.8V3.2C6.78571 2.08 6.78571 1.52 6.5645 1.092C6.36927 0.715343 6.0576 0.409138 5.67421 0.217333C5.23993 1.39078e-07 4.66993 0 3.52857 0H3.25714C2.11714 0 1.54714 1.39078e-07 1.1115 0.217333C0.728117 0.409138 0.416444 0.715343 0.221214 1.092ZM12.4355 1.092C12.2143 1.51867 12.2143 2.07867 12.2143 3.2V20.8C12.2143 21.92 12.2143 22.48 12.4369 22.908C12.632 23.284 12.9431 23.5897 13.3258 23.7813C13.7601 24 14.3301 24 15.4714 24H15.7429C16.8829 24 17.4529 24 17.8885 23.7827C18.2714 23.5906 18.5826 23.2845 18.7774 22.908C19 22.4813 19 21.9213 19 20.8V3.2C19 2.08 19 1.52 18.7788 1.092C18.5836 0.715343 18.2719 0.409138 17.8885 0.217333C17.4542 1.39078e-07 16.8842 0 15.7429 0H15.4714C14.3314 0 13.7614 1.39078e-07 13.3258 0.217333C12.9429 0.409364 12.6304 0.715546 12.4355 1.092Z" fill="white" />
                        </svg>
                      </a>
                      <input
                        className="ranger_player duration_slider"
                        id="duration_slider"
                        type="range"
                        min={0}
                        max={0.999999}
                        step="any"
                        value={played}
                        onMouseDown={handleSeekMouseDown}
                        onChange={handleSeekChange}
                        onMouseUp={handleSeekMouseUp}
                      />
                      <input
                        className="ranger_player volume_slider"
                        id="volume_slider"
                        type="range"
                        min={0}
                        max={1}
                        step="any"
                        value={volume}
                        onChange={handleVolumeLevel}
                      />
                      <span>
                        {fancyTimeFormat(elapsed)}
                        /
                        {fancyTimeFormat(duration)}
                      </span>
                      <a
                        href=""
                        id="fullscreen"
                        title="Fullscreen"
                        onClick={(e) => {
                          e.preventDefault();
                          handleClickFullscreen();
                        }}
                      >
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M8 2H4C2.89543 2 2 2.89543 2 4V8" stroke="white" strokeWidth="4" strokeLinecap="round" />
                          <path d="M22 8V4C22 2.89543 21.1046 2 20 2H16" stroke="white" strokeWidth="4" strokeLinecap="round" />
                          <path d="M16 22H20C21.1046 22 22 21.1046 22 20V16" stroke="white" strokeWidth="4" strokeLinecap="round" />
                          <path d="M8 22H4C2.89543 22 2 21.1046 2 20V16" stroke="white" strokeWidth="4" strokeLinecap="round" />
                        </svg>
                      </a>
                    </div>
                    <ReactPlayer
                      className="react-player"
                      id="player"
                      url={data.src}
                      controls={false}
                      width="100%"
                      height="auto"
                      config={{
                        file: {
                          attributes: {
                            controlsList: 'nodownload',
                          },
                        },
                      }}
                      playing={playing}
                      volume={volume}
                      onProgress={handleProgress}
                      ref={playerRef}
                      onDuration={handleDuration}
                    />
                  </div>
                </div>
                <div className="film-item__container">
                  <div className="film-item__img">
                    <img src={`${MAIN_URL}posters/${data.poster}`} alt="" />
                  </div>
                  <div className="film-item__content">
                    <div className="film-item__name">
                      <span>
                        <b>{data.name}</b>
                      </span>
                    </div>
                    <div className="film-item__text">
                      <table className="film_table">
                        <tbody>
                          {data.authors ? (
                            <tr style={{}}>
                              {data.authors.indexOf(',') > -1
                              || data.authors.indexOf('/') > -1
                              || data.authors.indexOf(';') > -1
                              || data.authors.indexOf('|') > -1 ? (
                                <>
                                  <th>
                                    <b>
                                      {dictionary.authors}
                                      :
                                    </b>
                                  </th>
                                  <td>
                                    {data.authors
                                      .replace(/,/g, '\n')
                                      .replace(/;/g, '\n')
                                      .replace(/\|/g, '\n')
                                      .replace(/\//g, '\n')}
                                  </td>
                                </>
                                ) : (
                                  <>
                                    <td>
                                      <b>
                                        {dictionary.author}
                                        :
                                      </b>
                                      {' '}
                                    </td>
                                    <td>{data.authors}</td>
                                  </>
                                )}
                            </tr>
                          ) : null}
                          {data.director ? (
                            <tr>
                              {data.director.indexOf(',') > -1
                              || data.director.indexOf('/') > -1
                              || data.director.indexOf(';') > -1
                              || data.director.indexOf('|') > -1 ? (
                                <>
                                  <th>
                                    <b>
                                      {dictionary.directors}
                                      :
                                    </b>
                                  </th>
                                  <td>
                                    {data.director
                                      .replace(/,/g, '\n')
                                      .replace(/;/g, '\n')
                                      .replace(/\|/g, '\n')
                                      .replace(/\//g, '\n')}
                                  </td>
                                </>
                                ) : (
                                  <>
                                    <th>
                                      <b>
                                        {dictionary.director}
                                        :
                                      </b>
                                      {' '}
                                    </th>
                                    <td>{data.director}</td>
                                  </>
                                )}
                            </tr>
                          ) : null}
                          {data.narrator ? (
                            <tr>
                              {data.narrator.indexOf(',') > -1
                              || data.narrator.indexOf('/') > -1
                              || data.narrator.indexOf(';') > -1
                              || data.narrator.indexOf('|') > -1 ? (
                                <>
                                  <th>
                                    <b>
                                      {dictionary.narrators}
                                      :
                                    </b>
                                  </th>
                                  <td>
                                    {data.narrator
                                      .replace(/,/g, '\n')
                                      .replace(/;/g, '\n')
                                      .replace(/\|/g, '\n')
                                      .replace(/\//g, '\n')}
                                  </td>
                                </>
                                ) : (
                                  <>
                                    <th>
                                      <b>
                                        {dictionary.narrator}
                                        :
                                      </b>
                                    </th>
                                    <td>{data.narrator}</td>
                                  </>
                                )}
                            </tr>
                          ) : null}
                          {data.editors ? (
                            <tr>
                              {data.editors.indexOf(',') > -1
                              || data.editors.indexOf('/') > -1
                              || data.editors.indexOf(';') > -1
                              || data.editors.indexOf('|') > -1 ? (
                                <>
                                  <th>
                                    <b>
                                      {dictionary.editors}
                                      :
                                    </b>
                                  </th>
                                  <td>
                                    {' '}
                                    {data.editors
                                      .replace(/,/g, '\n')
                                      .replace(/;/g, '\n')
                                      .replace(/\|/g, '\n')
                                      .replace(/\//g, '\n')}
                                  </td>
                                </>
                                ) : (
                                  <>
                                    <th>
                                      <b>
                                        {dictionary.editor}
                                        :
                                      </b>
                                    </th>
                                    <td>{data.editors}</td>
                                  </>
                                )}
                            </tr>
                          ) : null}
                          {data.computer_design ? (
                            <tr>
                              <th>
                                <b>
                                  {dictionary.computer_design}
                                  :
                                </b>
                              </th>
                              <td>
                                {' '}
                                {data.computer_design
                                  .replace(/,/g, '\n')
                                  .replace(/;/g, '\n')
                                  .replace(/\|/g, '\n')
                                  .replace(/\//g, '\n')}
                              </td>
                            </tr>
                          ) : null}

                          {data.team_leader ? (
                            <tr>
                              {data.team_leader.indexOf(',') > -1
                              || data.team_leader.indexOf('/') > -1
                              || data.team_leader.indexOf(';') > -1
                              || data.team_leader.indexOf('|') > -1 ? (
                                <>
                                  <th>
                                    <b>
                                      {dictionary.team_leaders}
                                      :
                                    </b>
                                  </th>
                                  <td>
                                    {data.team_leader
                                      .replace(/,/g, '\n')
                                      .replace(/;/g, '\n')
                                      .replace(/\|/g, '\n')
                                      .replace(/\//g, '\n')}
                                  </td>
                                </>
                                ) : (
                                  <>
                                    <th>
                                      <b>
                                        {dictionary.team_leader}
                                        :
                                      </b>
                                    </th>
                                    <td>{data.team_leader}</td>
                                  </>
                                )}
                            </tr>
                          ) : null}
                          {data.advicer ? (
                            <tr>
                              {data.advicer.indexOf(',') > -1
                              || data.advicer.indexOf('/') > -1
                              || data.advicer.indexOf(';') > -1
                              || data.advicer.indexOf('|') > -1 ? (
                                <>
                                  <th>
                                    <b>
                                      {dictionary.advicers}
                                      :
                                    </b>
                                  </th>
                                  <td>
                                    {data.advicer
                                      .replace(/,/g, '\n')
                                      .replace(/;/g, '\n')
                                      .replace(/\|/g, '\n')
                                      .replace(/\//g, '\n')}
                                  </td>
                                </>
                                ) : (
                                  <>
                                    <th>
                                      <b>
                                        {dictionary.advicer}
                                        :
                                      </b>
                                    </th>
                                    <td>{data.advicer}</td>
                                  </>
                                )}
                            </tr>
                          ) : null}
                          {data.year ? (
                            <tr>
                              <th>
                                <b>
                                  {dictionary.year}
                                  :
                                </b>
                              </th>
                              <td>{data.year}</td>
                            </tr>
                          ) : null}
                        </tbody>
                      </table>
                      {data.description ? (
                        <p>
                          <b>
                            {dictionary.description}
                            :
                          </b>
                          {data.description}
                        </p>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
          <div className="col-lg-3 pl-lg-4 d-none mt-5 d-lg-block">
            <div className="saidbar">
              <div className="saidbar-content">
                <EventMore />
              </div>
            </div>
          </div>
          <Map />
        </div>
      </div>
    </section>
  );
};

export default FilmById;
